<template>
  <section class="access-denied-page">
    <div class="container py-5 h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="access-denied-card shadow-lg">
            <div class="card-body p-4 p-sm-5 text-center">
              <img src="@/assets/trax.png" alt="Traxby" class="access-denied-logo mb-3">
              <h3 class="mb-3">Access blocked</h3>
              <p class="text-muted mb-3">{{ message }}</p>
              <p v-if="currentHost" class="small text-muted mb-0">Current address: {{ currentHost }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import {
  evaluateEnvironmentAccess,
  getSecurityMessage
} from '@/utils/securityPolicy'

export default {
  setup() {
    const route = useRoute()
    const environmentDecision = evaluateEnvironmentAccess()

    const message = computed(() => {
      const reason = typeof route.query.reason === 'string'
        ? route.query.reason
        : environmentDecision.reason

      return getSecurityMessage(reason)
    })

    const currentHost = computed(() => {
      if (typeof window === 'undefined') {
        return ''
      }

      return window.location.host || window.location.hostname || ''
    })

    return {
      currentHost,
      message
    }
  }
}
</script>

<style scoped>
.access-denied-page {
  min-height: 100vh;
  background: #101418;
}

.access-denied-card {
  background: #ffffff;
  border-radius: 8px;
}

.access-denied-logo {
  max-height: 48px;
  max-width: 160px;
}
</style>
